export const CREATE_ACTIVITY_CATEGORY = 'createActivityCategory';
export const FETCH_ACTIVITY_CATEGORY_BY_ID = 'fetchActivityCategoryById';
export const UPDATE_ACTIVITY_CATEGORY_BY_ID = 'updateActivityCategory';
export const FETCH_ORGANIZATION_ACTIVITY_CATEGORIES = 'fetchOrganizationActivityCategories';
export const DELETE_ACTIVITY_CATEGORY_BY_ID = 'deleteActivityCategoryById';
